import AutocheckinPage from "../pages";

const routes = [
  {
    path: "/",
    component: AutocheckinPage,
    title: "Es la home",
    needsAuth: true,
  },
  {
    path: "/mercadoPago",
    component: require("../pages/MercadoPagoDesktop/MercadoPagoDesktop")
      .default,
    title: "Mercado Pago",
    needsAuth: true,
  },
  {
    path: "/MercadoPagoQR",
    component: require("../pages/MercadoPagoQRDesktop/MercadoPagoQRDesktop")
      .default,
    title: "Mercado Pago QR",
    needsAuth: true,
  },
];

export default routes;
